/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const makeAppointmentBookingStyling = ({ iframeLoaded, showContent }) => {
  return {
    container: css({
      display: 'none',
      paddingLeft: '16px !important',
      paddingRight: '16px !important',
      ...(iframeLoaded &&
        showContent && {
          display: 'block',
        }),
    }),
    iframeContainer: css({
      display: 'flex',
      width: '100%',
    }),
    iframe: css({
      border: 'none',
      display: 'block',
      margin: '10px auto 0 auto',
      flexGrow: 1,
    }),
    grid: css({
      width: 0,
      ...(iframeLoaded &&
        showContent && {
          width: '100%',
        }),
    }),
  };
};

export default makeAppointmentBookingStyling;
